import { render, staticRenderFns } from "./project-code.vue?vue&type=template&id=52a595c5&scoped=true"
import script from "./project-code.component.ts?vue&type=script&lang=ts&external"
export * from "./project-code.component.ts?vue&type=script&lang=ts&external"
import style0 from "./project-code.vue?vue&type=style&index=0&id=52a595c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a595c5",
  null
  
)

export default component.exports